module.exports = __webpack_public_path__ + "b4d91661e8c1ed340e5b50967faa7007.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bagpipes.png
// module id = 1228
// module chunks = 0